import React, { Component } from "react";
import { loading, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import HeroGameOne from "../assets/images/game/image-02.png";
import HeroGameTwo from "../assets/images/game/image-14.png";
import HeroGameThree from "../assets/images/game/image-39.png";
import HeroGameFour from "../assets/images/game/image-58.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      password_view: "password",
    };
  }

  componentDidMount() {
    loading(false);
  }

  Login = async () => {
    const { email, password } = this.state;
    await fetch(
      `${"https://swiftgamepay-default-rtdb.asia-southeast1.firebasedatabase.app/"}user/${email.split("@")[0]}.json`,
      { method: "GET", headers: { "Content-Type": "application/json" } }
    )
      .then((response) => response.json())
      .then((data) => {
        if (btoa(password) !== data.password) {
          alert("", "warning", "แจ้งเตือน", "รหัสผ่านไม่ตรงกัน");
          return;
        }
        localStorage.setItem(
          "scp-profile",
          JSON.stringify({
            fullname: data.fullname,
            phone: data.phone,
            email: data.email,
            expired: new Date(
              new Date().setDate(new Date().getDate() + 2)
            ).getTime(),
          })
        );
        window.location.href = "/";
      })
      .catch(() => {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          "ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง"
        );
      });
  };

  render() {
    const { email, password, password_view } = this.state;
    return (
      <div className="login-page w-100 min-vh-100 position-relative overflow-hidden">
        <div className="login-page__ambient login-page__ambient--one"></div>
        <div className="login-page__ambient login-page__ambient--two"></div>
        <div className="login-page__grid"></div>

        <Navbar />

        <div className="container position-relative py-4 py-lg-5">
          <div className="login-shell row g-0 overflow-hidden">
            <div className="col-12 col-lg-5">
              <div className="login-form-panel">
                <span className="login-kicker">Member Access</span>
                <h1 className="login-title">เข้าสู่ระบบ</h1>
                <p className="login-description">
                  เข้าสู่ระบบเพื่อเติมเกม ดูแพ็กยอดนิยม และใช้งาน Lvup Topup ได้
                  อย่างรวดเร็วในที่เดียว
                </p>

                <label className="login-label">อีเมล</label>
                <input
                  className="form-control login-input mb-3"
                  type="text"
                  placeholder="อีเมล"
                  onChange={(e) => {
                    this.setState({ email: e.target.value });
                  }}
                  value={email}
                />

                <label className="login-label">รหัสผ่าน</label>
                <div className="position-relative">
                  <input
                    className="form-control login-input mb-3"
                    type={password_view}
                    placeholder="รหัสผ่าน"
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        this.Login();
                      }
                    }}
                    value={password}
                  />
                  <div
                    className="login-password-toggle icon pointer position-absolute"
                    onClick={() => {
                      this.setState({
                        password_view:
                          password_view === "password" ? "text" : "password",
                      });
                    }}
                  >
                    {password_view === "password" ? "\uf06e" : "\uf070"}
                  </div>
                </div>

                <button
                  type="button"
                  className="btn login-submit w-100 mb-3"
                  onClick={() => {
                    this.Login();
                  }}
                >
                  เข้าสู่ระบบ
                </button>

                <div className="login-links text-center">
                  <a className="text-decoration-none" href="/register">
                    สมัครสมาชิก
                  </a>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-7 d-none d-lg-block">
              <div className="login-visual-panel">
                <div className="login-visual__glow login-visual__glow--gold"></div>
                <div className="login-visual__glow login-visual__glow--blue"></div>

                <div className="login-visual__card login-visual__card--back">
                  <img src={HeroGameTwo} alt="" />
                </div>
                <div className="login-visual__card login-visual__card--left">
                  <img src={HeroGameOne} alt="" />
                </div>
                <div className="login-visual__card login-visual__card--right">
                  <img src={HeroGameThree} alt="" />
                </div>
                <div className="login-visual__card login-visual__card--front">
                  <img src={HeroGameFour} alt="" />
                </div>

                <div className="login-brand-stage">
                  <span className="login-brand-stage__badge">
                    GAME TOP-UP STORE
                  </span>
                  <div className="login-brand-stage__wordmark">Lvup Topup</div>
                  <p>เติมเกมออนไลน์แบบพรีเมียม รวดเร็ว และพร้อมใช้งานตลอด 24 ชม.</p>
                  <div className="login-brand-stage__chips">
                    <span>Top-up Ready</span>
                    <span>Trusted Service</span>
                    <span>Premium Access</span>
                  </div>
                </div>

                <div className="login-visual__token login-visual__token--one">
                  720 Diamonds
                </div>
                <div className="login-visual__token login-visual__token--two">
                  325 UC
                </div>
                <div className="login-visual__token login-visual__token--three">
                  Bonus Coins
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
